import { SortState, SingleSortType, MultiSortState } from '../types/state';

export const createSortingAdapter = <SliceState, SortColumnType extends string>({
  selectState,
  reset,
}: {
  selectState: (state: SliceState) => SortState<SortColumnType>;
  reset?: (state: SliceState) => void;
}) => ({
  setSort: (sliceState: SliceState, { payload: sort }: { payload: SingleSortType<SortColumnType> }) => {
    const state = selectState(sliceState);
    reset?.(sliceState);
    state.sortState = sort;
  },
  resetSort: (sliceState: SliceState) => {
    const state = selectState(sliceState);
    reset?.(sliceState);
    state.sortState = undefined;
  },
});

export const createMultiColumnSortingAdapter = <SliceState, SortColumnType extends string>({
  selectState,
  reset,
}: {
  selectState: (state: SliceState) => MultiSortState<SortColumnType>;
  reset?: (state: SliceState) => void;
}) => ({
  setSort: (sliceState: SliceState, { payload: sort }: { payload: SingleSortType<SortColumnType> }) => {
    const state = selectState(sliceState);
    reset?.(sliceState);
    if (!state?.sortState) {
      state.sortState = [sort];
      return;
    }
    const existingIndex = state.sortState.findIndex(s => s.column === sort.column);
    if (existingIndex !== -1) {
      state.sortState[existingIndex] = sort;
    } else {
      state.sortState.push(sort);
    }
  },
  setSorts: (sliceState: SliceState, { payload: sorts }: { payload: SingleSortType<SortColumnType>[] }) => {
    const state = selectState(sliceState);
    state.sortState = sorts;
  },
  resetSort: (sliceState: SliceState) => {
    const state = selectState(sliceState);
    reset?.(sliceState);
    state.sortState = undefined;
  },
});
